import { useState, useCallback } from 'react';

export interface NotificationItem {
    id: string;
    type: 'success' | 'error' | 'warning' | 'info';
    title: string;
    message?: string;
    duration?: number;
}

export const useNotification = () => {
    const [notifications, setNotifications] = useState<NotificationItem[]>([]);

    const showNotification = useCallback((
        type: 'success' | 'error' | 'warning' | 'info',
        title: string,
        message?: string,
        duration?: number
    ) => {
        console.log('🔍 useNotification: showNotification called with:', { type, title, message, duration });
        const id = Date.now().toString() + Math.random().toString(36).substr(2, 9);
        const newNotification: NotificationItem = {
            id,
            type,
            title,
            message,
            duration: duration || 3000
        };

        console.log('🔍 useNotification: Creating notification:', newNotification);
        setNotifications(prev => {
            const updated = [...prev, newNotification];
            console.log('🔍 useNotification: Updated notifications array:', updated);
            return updated;
        });

        // Auto-remove notification after duration
        setTimeout(() => {
            removeNotification(id);
        }, duration || 3000);
    }, []);

    const removeNotification = useCallback((id: string) => {
        setNotifications(prev => prev.filter(notification => notification.id !== id));
    }, []);

    const showSuccess = useCallback((title: string, message?: string, duration?: number) => {
        console.log('🔍 useNotification: showSuccess called with:', { title, message, duration });
        showNotification('success', title, message, duration);
    }, [showNotification]);

    const showError = useCallback((title: string, message?: string, duration?: number) => {
        showNotification('error', title, message, duration);
    }, [showNotification]);

    const showWarning = useCallback((title: string, message?: string, duration?: number) => {
        showNotification('warning', title, message, duration);
    }, [showNotification]);

    const showInfo = useCallback((title: string, message?: string, duration?: number) => {
        showNotification('info', title, message, duration);
    }, [showNotification]);

    return {
        notifications,
        showNotification,
        showSuccess,
        showError,
        showWarning,
        showInfo,
        removeNotification
    };
}; 